<template>
  <div>
    <router-view></router-view>
  </div>

</template>

<script>


export default {

  setup()
  {

  },
}
</script>


<style>
</style>
